<template>
  <div v-if="shownProducts.length && shownProducts.length >=6" class="mb-1 mt-1">
    <div class="product-list row mx-sm-0">
      <div class="col-12 px-0">
        <template v-if="renderCarousel">
          <Carousel
            :value="shownProducts"
            :numVisible="3"
            :numScroll="3"
            :circular="true"
            :responsiveOptions="responsiveOptions"
          >
            <template #header>
              <inertia-link
                v-if="viewAllRoute"
                :href="viewAllRoute" 
                class="cursor-pointer text-dark ml-2"
              >
                <p class="badge bg-light border border-dark mb-0 px-3 py-1 featured-header text-size-small">
                  {{title}} 
                  <span class="text-size-small pl-3">
                    <i class="fas fa-angle-right mr-1"></i>View All
                  </span>
                </p>
              </inertia-link>

              <p v-else
                @click="viewAllClicked" 
                class="badge border mb-0 px-3 py-1 featured-header text-size-small cursor-pointer" 
                :class="[
                  {'bg-primary text-white border-light': viewAllSelected}, 
                  {'bg-light border-dark': !viewAllSelected}
                ]"
              >
                {{title}}
                <a data-toggle="popover"
                  :data-content="info"
                  data-trigger="focus" 
                  data-position="bottom" 
                  tabindex="0"
                  @click.stop>
                  <i class="fas fa-info-circle" :class="[{'text-white':viewAllSelected}, {'text-dark': !viewAllSelected}]"></i>
                </a>

                <span class="text-size-small pl-3">
                  View All <i class="fas fa-angle-right mr-1"></i>
                </span>
              </p>
              
            </template>
            <template #item="slotProps">
              <ShopItem
                layoutStyle="compact"
                :product="slotProps.data"
                :selectedAttribute="selectedAttribute"
                :productLink="productLink"
                :cart_items="cart_items"
                :routes="routes"
                class="h-100"
                :is_suggested="is_suggested" 
                :suggested_type="suggested_type" 
                :isWholesale="isWholesale"
                @getCartItems="$emit('getCartItems')"
              />
            </template>
          </Carousel>
        </template>

        <template v-else>
          <inertia-link
            v-if="viewAllRoute"
            :href="viewAllRoute" 
            class="cursor-pointer text-dark ml-2"
            >
            <p class="badge bg-light border border-dark mb-0 px-3 py-1 featured-header text-size-small">
              {{title}} 
              <span class="text-size-small pl-3">
                <i class="fas fa-angle-right mr-1"></i>View All
              </span>
            </p>
          </inertia-link>

          <p v-else
            @click="viewAllClicked" 
            class="badge border mb-0 px-3 py-1 featured-header text-size-small cursor-pointer" 
            :class="[
              {'bg-primary text-white border-light': viewAllSelected}, 
              {'bg-light border-dark': !viewAllSelected}
            ]"
          >
            {{title}}

            <span class="text-size-small pl-3">
              View All <i class="fas fa-angle-right mr-1"></i>
            </span>
          </p>
          <div class="row">
            <div v-for="(product, index) in shownProducts" :key="product.id" class="col px-1 product-container">
              <ShopItem
                layoutStyle="compact"
                :product="product"
                :productLink="productLink"
                :cart_items="cart_items"
                :routes="routes"
                class="h-100"
                :class="index > 3 ? 'd-none' : ''"
                :is_suggested="true" 
                suggested_type="featured" 
                :isWholesale="isWholesale"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import ShopItem from '@/Components/Shop/ShopItem'
  import Carousel from 'primevue/carousel'

  export default {
    data() {
      return {
        renderCarousel: true,
        selectedAttribute: {},
        shownProducts: this.products,
        responsiveOptions: [
          {
            breakpoint: '992px',
            numVisible: 2,
            numScroll: 2
          },
          {
            breakpoint: '767px',
            numVisible: 1,
            numScroll: 1
          }
        ]
      }
    },
    components: {
      ShopItem,
      Carousel
    },
    props: {
      title: String,
      routes: Object,
      products: Array,
      productLink: String,
      viewAllRoute: String,
      cart_items: [Boolean, Array],
      is_suggested: Boolean,
      suggested_type: String,
      viewAllSelected: Boolean,
      isWholesale: Boolean,
      info: String
    },
    mounted() {
      if (this.products && this.products.length >= 12) this.shownProducts = this.products.slice(0,12)
      else if (this.products && this.products.length >= 6) this.shownProducts = this.products.slice(0,6)
      this.makeSelectedAttributes()
    },
    methods: {
      makeSelectedAttributes() {
        const filteredProducts = this.shownProducts.filter(product => { return product.attributes && product.attributes.length === 1 })

        if (filteredProducts.length) {
          filteredProducts.forEach(product => this.selectedAttribute[product.id] = 0)
        }
      },
      viewAllClicked() {
        this.$emit('viewAllButtonClicked', this.viewAllSelected ? null : this.suggested_type)
      }
    }
  }
</script>

<style >
  .product-list .p-component.p-carousel {
    /* Reset styles set by prime vue component */
    font-family: inherit;
    font-size: inherit;
  }

  .product-list .p-carousel .p-carousel-indicators {
    display: none;
  }

  .product-list .p-carousel-items-content {
    margin-right: -3px;
  }
</style>
